import { PATHS } from '@belong/common';
import { Text } from '@belong/ui';
import { DEFAULT_LINKS } from 'consts/links';
import LinkBase from 'corecomponents/LinkBase/LinkBase';

/**
 * There are no `propTypes` or defaults here, so without this the destructured
 * `className` is inferred as a required prop and every call site that omits it —
 * all of them do; it only styles the desktop variant — is an error.
 *
 * @param {{ className?: string }} props
 */
export function ContactUs({ className }) {
  return (
    <>
      <div className="mb-xl flex md:hidden">
        <LinkBase href={PATHS.SUPPORT}>
          <Text className="text-navy" variant="h3" fontWeight="semibold">
            {DEFAULT_LINKS.GET_HELP_NEW.label}
          </Text>
        </LinkBase>
      </div>
      <div className="hidden md:flex lg:ml-sm">
        <LinkBase href={PATHS.SUPPORT}>
          <Text variant="p1" fontWeight="semibold" className={className}>
            GET HELP 24/7
          </Text>
        </LinkBase>
      </div>
    </>
  );
}
